import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _isNumber from "lodash/isNumber";

var _params;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import classes from '@nerdwallet/base-styles/classes';
import classNames from 'classnames';
import Type from '@nerdwallet/react-typography';
import Popover from '@nerdwallet/react-popover';
import { colors } from '@nerdwallet/base-styles/variables';
import { Tracking } from '@nerdwallet/nw-client-lib';
import { setTrk, TrkTag, TrkElement } from '@nerdwallet/nw-client-lib/trk-helper';
import gradientStringBuilder from './utils';
import * as styles from '../approval-odds.module.less';
var LAYOUT = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
};
export var AO_COLORS = {
  DEFAULT: colors['neutral-lighter'],
  DEFAULT_BACKGROUND: colors['neutral-lightest'],
  LOW: colors['red-light'],
  MEDIUM: colors.yellow,
  HIGH: colors['green-dark']
};
export var AO_RANGES = {
  LOW: {
    min: 0,
    max: 0.45
  },
  MEDIUM: {
    min: 0.45,
    max: 0.65
  },
  HIGH: {
    min: 0.65,
    max: 1
  }
};
export var CREDIT_DASHBOARD_PATH = '/home/dashboard/credit-score';
export var CREDIT_DASHBOARD_PATH_WITH_TRK = setTrk({
  url: CREDIT_DASHBOARD_PATH,
  params: (_params = {}, _defineProperty(_params, TrkTag.element, TrkElement.hyperlink), _defineProperty(_params, TrkTag.location, 'approval_odds'), _params)
}); // TODO: when AO component has been launched, move this logic to nw-client-lib utils for sharing
// see https://github.com/NerdWallet/react-components/pull/1041#discussion_r219310105

export function calculateBucket(approvalOdds) {
  if (approvalOdds >= 0.05 && approvalOdds < 0.15) {
    return {
      percentile: 10,
      numSegments: 0.5
    };
  } else if (approvalOdds >= 0.15 && approvalOdds < 0.25) {
    return {
      percentile: 20,
      numSegments: 1
    };
  } else if (approvalOdds >= 0.25 && approvalOdds < 0.35) {
    return {
      percentile: 30,
      numSegments: 1.5
    };
  } else if (approvalOdds >= 0.35 && approvalOdds < 0.45) {
    return {
      percentile: 40,
      numSegments: 2
    };
  } else if (approvalOdds >= 0.45 && approvalOdds < 0.55) {
    return {
      percentile: 50,
      numSegments: 2.5
    };
  } else if (approvalOdds >= 0.55 && approvalOdds < 0.65) {
    return {
      percentile: 60,
      numSegments: 3
    };
  } else if (approvalOdds >= 0.65 && approvalOdds < 0.75) {
    return {
      percentile: 70,
      numSegments: 3.5
    };
  } else if (approvalOdds >= 0.75 && approvalOdds < 0.85) {
    return {
      percentile: 80,
      numSegments: 4
    };
  } else if (approvalOdds >= 0.85) {
    return {
      percentile: 90,
      numSegments: 4.5
    };
  }

  return {
    percentile: 0,
    numSegments: 0
  };
}
/**
 * Returns the popover content for approval odds.
 *
 * @param {number} approvalOdds
 * @param {object} styles
 */

export var approvalOddsPopoverContent = function approvalOddsPopoverContent(approvalOdds) {
  return React.createElement("div", {
    className: styles.popoverContent
  }, React.createElement("p", null, React.createElement("strong", null, calculateBucket(approvalOdds).percentile / 10, " in 10 NerdWallet members (with credit like yours) were approved for this card.\xA0"), "Wondering what lenders look for? Credit score, among other factors. But, heads up, they may not use the TransUnion Vantage Score 3.0 like we do, and these odds don't guarantee denial or approval."));
}; //

/**
 * Returns color of approval bar and labels
 *
 * @param {object} props
 */

export var getColorAndLabel = function getColorAndLabel(props) {
  var approvalOdds = props.approvalOdds;

  if (approvalOdds < AO_RANGES.LOW.max) {
    return {
      color: AO_COLORS.LOW,
      label: 'low'
    };
  } else if (approvalOdds >= AO_RANGES.MEDIUM.min && approvalOdds < AO_RANGES.MEDIUM.max) {
    return {
      color: AO_COLORS.MEDIUM,
      label: 'medium'
    };
  } else if (approvalOdds >= AO_RANGES.HIGH.min) {
    return {
      color: AO_COLORS.HIGH,
      label: 'high'
    };
  }

  return {
    color: AO_COLORS.DEFAULT,
    label: ''
  };
}; // Require tracking props if useTracking is true
// needs to not return anything if the prop is valid
// eslint-disable-next-line consistent-return

var validateTrackingProps = function validateTrackingProps(props, propName) {
  if (props.useTracking) {
    if (props[propName] === undefined || typeof props[propName] !== 'string' && typeof props[propName] !== 'number') {
      return new Error("".concat(propName, " is required when useTracking is true. Please provide a valid prop."));
    }
  }
};

var CCElementImpression = Tracking.CCElementImpressionConnect;
var CCElementInteraction = Tracking.CCElementInteractionConnect;
var colorsArray = Object.keys(colors);

var ApprovalOdds =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ApprovalOdds, _React$Component);

  function ApprovalOdds() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ApprovalOdds);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ApprovalOdds)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "createApprovalBar", function () {
      var backgroundColor = colors[_this.props.backgroundColor];

      var _getColorAndLabel = getColorAndLabel(_this.props),
          color = _getColorAndLabel.color;

      var _calculateBucket = calculateBucket(_this.props.approvalOdds),
          numSegments = _calculateBucket.numSegments,
          percentile = _calculateBucket.percentile;

      var defaultBarColor = colors['neutral-lighter'];
      var colorBarStyles = {
        borderLeft: "2px solid ".concat(backgroundColor),
        borderRight: "2px solid ".concat(backgroundColor)
      };
      return React.createElement("div", null, React.createElement("div", {
        style: _objectSpread({}, colorBarStyles, {
          background: gradientStringBuilder(defaultBarColor, backgroundColor),
          width: '100%'
        }),
        className: classNames('approval-odds-bar__background', styles.bar)
      }), React.createElement("div", {
        className: classNames('approval-odds-bar__color', styles.bar),
        style: _objectSpread({}, colorBarStyles, {
          background: gradientStringBuilder(color, backgroundColor, numSegments),
          width: "".concat(percentile, "%")
        })
      }));
    });

    return _this;
  }

  _createClass(ApprovalOdds, [{
    key: "calculateMarkerPosition",
    // Returns the css for the left offset percent of the credit score marker
    value: function calculateMarkerPosition(shouldOffsetMarker) {
      var bucket = calculateBucket(this.props.approvalOdds).percentile;

      if (bucket === 0) {
        return '0%';
      } else if (shouldOffsetMarker && bucket % 20 === 0) {
        // marker appears at the end of a segment, remove some padding to show space
        return "calc(".concat(bucket, "% - 11px)");
      } // marker appears within a segment - remove some padding so marker completely covers end of colored line


      return "calc(".concat(bucket, "% - 1px)");
    } // Returns the markup for the text below the approval bar

  }, {
    key: "render",
    // eslint-disable-next-line react/sort-comp
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          approvalOdds = _this$props.approvalOdds,
          cardId = _this$props.cardId,
          id = _this$props.id,
          impressionKey = _this$props.impressionKey,
          layout = _this$props.layout,
          modelExecutionIds = _this$props.modelExecutionIds,
          sectionCategory = _this$props.sectionCategory,
          sectionPosition = _this$props.sectionPosition,
          useTracking = _this$props.useTracking,
          width = _this$props.width; // handle null case

      if (!_isNumber(approvalOdds)) {
        return false;
      }

      var _getColorAndLabel2 = getColorAndLabel(this.props),
          color = _getColorAndLabel2.color,
          label = _getColorAndLabel2.label;

      var impressionFields = {
        id: "".concat(cardId, "-approval-odds"),
        elementDomId: Number(cardId),
        elementName: 'Approval Odds',
        elementCategory: label.toUpperCase(),
        elementContent: approvalOdds.toString(),
        modelExecutionIds: modelExecutionIds,
        sectionCategory: sectionCategory,
        sectionPosition: sectionPosition,
        productId: cardId,
        productImpressionKey: impressionKey
      };
      var elementId = "".concat(this.props.id, "__marker");
      var markerOffset = this.calculateMarkerPosition(true);
      var markerStyle = {
        marginLeft: markerOffset,
        backgroundColor: color
      };
      var contentStyle = {
        maxWidth: layout === LAYOUT.HORIZONTAL ? width : null
      };

      var barMarkup = function barMarkup() {
        var markup = React.createElement("div", {
          className: classNames(styles.top, classes(['width-100'])),
          style: contentStyle,
          key: cardId
        }, _this2.createApprovalBar(), React.createElement(Type, {
          className: classNames(styles.marker, 'approval-odds-marker'),
          id: elementId,
          size: 1,
          style: markerStyle
        }, label));

        if (useTracking) {
          return React.createElement(CCElementInteraction, _extends({}, impressionFields, {
            type: "HOVER"
          }), markup);
        }

        return markup;
      };

      var aoComponent = React.createElement("div", {
        "aria-label": "Your approval odds for this card are ".concat(label, "."),
        className: "approval-odds"
      }, React.createElement("div", {
        className: classNames(styles["layout".concat(layout)], classes(['display-flex', 'flex-wrap', 'flex-direction-column', // Force column layout on small viewports
        'flex-direction-row--wide', 'align-items-center--wide', 'padding-vertical-3', 'width-100', {
          'justify-content-space-between--wide': layout === LAYOUT.HORIZONTAL
        }]))
      }, React.createElement(Popover, {
        id: "".concat(id, "__popover"),
        type: ['click', 'hover'],
        placement: "top",
        popoverClassName: styles.popoverContainer,
        popoverContent: approvalOddsPopoverContent(this.props.approvalOdds),
        className: classNames('ao-popover-icon', // for ease of unit testing
        classes(['display-block', 'width-100']))
      }, barMarkup())));

      if (useTracking) {
        return React.createElement(CCElementImpression, impressionFields, aoComponent);
      }

      return aoComponent;
    }
  }]);

  return ApprovalOdds;
}(React.Component);

_defineProperty(ApprovalOdds, "colorsArray", colorsArray);

_defineProperty(ApprovalOdds, "propTypes", {
  /** Number between 0 and 1, supplied by the Offer API */
  approvalOdds: PropTypes.number.isRequired,

  /** ID of the card offer for which the approval odds has been rendered. */
  cardId: validateTrackingProps,

  /** Unique id string for the component */
  id: PropTypes.string.isRequired,

  /**
   * Background color of the container in which the component appears.
   * Allows for spaces between segments to appear transparent.
   */
  backgroundColor: PropTypes.oneOf(colorsArray),

  /** CC-specific tracking identifier, required if useTracking is true */
  impressionKey: validateTrackingProps,

  /** With the width prop, determines the width of the component */
  layout: PropTypes.oneOf([LAYOUT.HORIZONTAL, LAYOUT.VERTICAL]),

  /** Tracking information, required if useTracking is true */
  sectionCategory: validateTrackingProps,

  /** Tracking information, required if useTracking is true */
  sectionPosition: validateTrackingProps,

  /** Tracking information, optional */
  modelExecutionIds: PropTypes.arrayOf(PropTypes.string),

  /**
   * Boolean to send tracking information. If true, then supply
   * impressionKey, sectionCategory, sectionPosition props.
   */
  useTracking: PropTypes.bool,

  /** Define a fixed width. */
  width: PropTypes.number
});

_defineProperty(ApprovalOdds, "defaultProps", {
  backgroundColor: 'neutral-lightest',
  cardId: null,
  layout: 'vertical',
  sectionCategory: '',
  sectionPosition: '',
  impressionKey: null,
  modelExecutionIds: [],
  useTracking: false,
  width: null
});

export default ApprovalOdds;